import { create } from 'zustand'

interface FilterListVisibilityStore {
  filtersFormVisible: boolean
  setFiltersFormVisible: (visible: boolean) => void
}

export const createFilterListStore = () => {
  const useFilterListVisibilityStore = create<FilterListVisibilityStore>((set) => ({
    filtersFormVisible: false,
    setFiltersFormVisible: (visible: boolean) => set({ filtersFormVisible: visible }),
  }))

  return {
    useFilterListVisibilityStore,
  }
}
